<script lang="ts">
	//Design system components
	import { Select, Text, Container } from '@Shelly/shelly-design-system';
	//Svelte hooks
	import { createEventDispatcher, getContext } from 'svelte';
	//Components
	import BrightnessWrapper from './BrightnessWrapper.svelte';
	import DurationWrapper from './DurationWrapper.svelte';
	import TemperatureWheelWrapper from './TemperatureWheelWrapper.svelte';
	import ActionSelectionWrapper from './ActionSelectionWrapper.svelte';

	const scheduleStore: SvelteStore<any> = getContext('schedule');
	let options = $scheduleStore._options;
	if (options.includes('brightness')) {
		options.pop(); //this component is mostly for Duo devices because here we can sent on and off plus brightness. So removing select brightness option and also no disabled prop
	}
	scheduleStore.change({ _options: options });
	let selection =
		$scheduleStore._options[$scheduleStore.options.indexOf($scheduleStore.selection)] ||
		$scheduleStore._options[0];
	const dispatch = createEventDispatcher();

	const updateData = (e) => {
		// selection = $scheduleStore._options[2];
		dispatch('update', e.detail);
	};
</script>

<ActionSelectionWrapper
	{selection}
	on:update={(e) => {
		selection = e.detail.selection;
		updateData(e);
	}}
/>

<Container padding="scrollPaddings">
	<hr class="mt-l mb-l" />
	<BrightnessWrapper on:update={updateData} />
	<hr class="mt-l mb-l" />
</Container>
<Container padding="scrollPaddings">
	<TemperatureWheelWrapper on:update={updateData} />
	<hr class="mt-l mb-l" />
</Container>
<DurationWrapper on:update={updateData} />
